import type { Provider } from "@src/interfaces/provider.interface";
import { normalizeSessionTypeToken } from "@src/utils/session-type-normalization";

export const normalizeModalityToken = normalizeSessionTypeToken;

export const filterProvidersByRequestedModality = (
  providers: Provider[],
  requestedModality?: string,
): Provider[] => {
  const normalizedRequestedModality = requestedModality
    ? normalizeModalityToken(requestedModality)
    : "no preference";

  if (normalizedRequestedModality === "no preference") {
    return providers;
  }

  return providers.filter((provider) => {
    const providerModalities = Array.isArray(provider.modality)
      ? provider.modality.map((modality) => normalizeModalityToken(modality))
      : [];

    if (providerModalities.length === 0) {
      return true;
    }

    return providerModalities.includes(normalizedRequestedModality);
  });
};

export const orderVirtualOnlyProvidersLast = (providers: Provider[]): Provider[] => {
  const providersWithInPerson = providers.filter((provider) => {
    const modalities = Array.isArray(provider.modality)
      ? provider.modality.map((modality) => normalizeModalityToken(modality))
      : [];

    return !modalities.includes("telehealth") || modalities.includes("in-person");
  });
  const virtualOnlyProviders = providers.filter((provider) => {
    const modalities = Array.isArray(provider.modality)
      ? provider.modality.map((modality) => normalizeModalityToken(modality))
      : [];

    return modalities.includes("telehealth") && !modalities.includes("in-person");
  });

  return [...providersWithInPerson, ...virtualOnlyProviders];
};
